module.exports = __webpack_public_path__ + "img/1F1E8-1F1FE.0a6a6681.svg";